var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilledoff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.989 9.043 10.46 15.95l-4.45-4.084.946-1.031 3.504 3.215 6.581-6.039.947 1.032Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.3 12C1.3 6.09 6.09 1.3 12 1.3c5.91 0 10.7 4.79 10.7 10.7 0 5.91-4.79 10.7-10.7 10.7-5.91 0-10.7-4.79-10.7-10.7ZM12 2.7a9.3 9.3 0 1 0 0 18.6 9.3 9.3 0 0 0 0-18.6Z"
})));
export { SvgFilledoff as ReactComponent };
export default __webpack_public_path__ + "21f299964265d8c06fcb8d11f7e6f8ed.svg";